/**
 * The new-chat greeting, by the loan officer's first name when the page knows it (the web app
 * passes the signed-in name, e.g. from Google, as `name` in the sidebar URL).
 */

// The web app sends `name=undefined` when the session has none; the sidebar falls back to "You".
const NOT_A_NAME = new Set(["", "you", "undefined", "null"]);

/** "Shaun Peterson" → "Shaun"; "" when there is no usable name (missing, a placeholder or an email). */
export const firstName = (name) => {
  const first = String(name ?? "").trim().split(/\s+/)[0] || "";
  if (NOT_A_NAME.has(first.toLowerCase()) || first.includes("@")) {
    return "";
  }

  return first;
};

export const welcomeTitle = (name) => {
  const first = firstName(name);

  return first ? `${first}, how can I help you today?` : "How can I help you today?";
};
